import { render, staticRenderFns } from "./EmergencyMessages.vue?vue&type=template&id=4818272c&scoped=true"
import script from "./EmergencyMessages.vue?vue&type=script&lang=js"
export * from "./EmergencyMessages.vue?vue&type=script&lang=js"
import style0 from "./EmergencyMessages.vue?vue&type=style&index=0&id=4818272c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4818272c",
  null
  
)

export default component.exports